/**
 * ForwardIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const ForwardIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M3.09 19.6q.466 0 .777-.312.312-.311.312-.778v-3.96q0-1.392.967-2.351t2.344-.96h10.803l-3.234 3.234a.97.97 0 0 0-.29.737q.007.439.317.764.325.325.772.325t.772-.325l5.06-5.06a1 1 0 0 0 .24-.36q.07-.193.07-.404t-.07-.404a1 1 0 0 0-.24-.36l-5.088-5.088A1 1 0 0 0 15.858 4q-.447 0-.772.325a1.05 1.05 0 0 0-.325.764q0 .44.325.764l3.207 3.207H7.49q-2.27 0-3.88 1.597T2 14.55v3.96q0 .466.311.778.312.312.778.312" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const ForwardIcon = makeIcon('ForwardIcon', ForwardIconSvg)
